export default __webpack_public_path__ + "static/media/favorite-unfill.c18eca71.svg";